import styled, { css } from 'styled-components';
import { cond, propEq, always, T } from 'ramda';

import { media } from '../../utils/media';

export const Header = styled.div`
  color: ${({ theme }) => theme.color};
  border-bottom: 2px solid ${({ theme }) => theme.color};
  display: flex;
`;

const columnStyle = css`
  width: 100%;
  flex: 0 0 auto;

  ${media.tablet`
    width: 210px;
  `}

  ${media.desktop`
    width: 290px;
  `}

  ${media.desktopWide`
    width: 390px;
  `}
`;

export const HeaderColumn = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43em;
  letter-spacing: 0.35px;
  ${cond([
    [
      propEq('column', 'PILLARS'),
      always(css`
        flex: 1;

        ${media.tablet`
        margin-left: 52px;
        width: 220px;
      `}
      `),
    ],
    [
      T,
      always(css`
        display: none;

        ${media.tablet`
        display: block;
        padding-left: 45px;
      `}

        ${columnStyle}
      `),
    ],
  ])}
`;

export const Table = styled.div`
  line-height: 2em;
  letter-spacing: 0.3px;
  font-size: 12px;
`;

export const Pillar = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color};
  display: flex;
  flex-direction: column;

  ${media.tablet`
    flex-direction: row;
  `}
`;

export const PillarHeader = styled.div`
  display: flex;
  margin: 11px 0;
  cursor: pointer;
  flex-flow: wrap;
  width: 220px;

  ${media.tablet`
    flex-direction: row;
    margin: 0;
    cursor: default;
  `}

  svg {
    flex: 0 0 auto;
    width: 40px;
    height: 40px;
    fill: ${({ theme }) => theme.color};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.color};

    ${media.tablet`
      margin-top: 10px;
    `}
  }
`;

export const PillarTitle = styled.div`
  display: inline-block;
  margin: auto 12px;
  line-height: 1.17em;
  text-transform: uppercase;
  font-weight: 500;
  color: ${({ theme }) => theme.color};
  flex: 1;

  ${media.tablet`
    margin: 19px 28px 9px 12px;
  `}
`;

export const PillarContent = styled.div`
  padding-left: 29px;
  overflow: hidden;
  transition: height 0.3s;
  height: 0;

  ${media.tablet`
    padding: 0;
    height: auto !important;
    display: block;
  `}
`;

export const Indicator = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color};
  background-color: ${({ useColor, theme }) => useColor && theme.background};
  display: flex;
  flex-direction: column;

  :first-child {
    border-top: 1px solid ${({ theme }) => theme.color};
  }

  :last-child {
    border-bottom: none;
    margin-bottom: 24px;
  }

  ${media.tablet`
    flex-direction: row;

    :first-child {
      border-top: none;
    }

    :last-child {
      margin-bottom: 0
    }
  `}
`;

export const IndicatorHeader = styled.div`
  display: flex;
  ${columnStyle}

  ${media.tablet`
    flex-direction: row;
  `}
`;

export const IndicatorTitle = styled.div``;

export const IndicatorContent = styled.div`
  ${columnStyle}
`;

export const Dimension = styled.div`
  display: flex;
  margin-left: 33px;

  ${media.tablet`
    margin-left: 0;
  `}
`;

export const DimensionContent = styled.div`
  flex: 1;
`;

export const NumberItem = styled.div`
  flex: 0 0 auto;
  width: 45px;
  text-align: right;
  padding-right: 15px;
`;
